import "./CommonModal.scss";
import { Box, Button } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import modalTypes from './ModalTypes'
import constants from '../../constants';

export default function CommonModal( { type, toggleModal, action, selectedUserId } ) {
  const { instance } = useMsal();
  const selectedType = modalTypes[type];
  
  function logout() {
    instance.logout();
  }

  return (

    <Box className={`${type === constants.restrict ? constants.restrictModal : constants.commonModal }`}>
      <Box className={`${type === constants.restrict ? constants.mobileModal : constants.commonModalContainer }`}>
        {selectedType.modalTitle !== undefined && <Box className='modal-title'>{selectedType.modalTitle}</Box>}
        { type === constants.remove ? 
           <Box className='modal-msg'>{selectedType.modalMsg} <Box class='modal-user-id'>{selectedUserId}</Box></Box> : <Box className='modal-msg'>{selectedType.modalMsg}</Box>
        }        
        <Box className='modal-subtxt'>{selectedType.modalSubtxt}</Box>
        {(type === constants.restrict && 
          <Button className='modal-logout' onClick={logout}>Log out</Button>
        )}
        {(type === constants.remove && 
          <>
            <Box className='modal-subtxt'>{selectedType.modalSubtxt2}</Box>
            <Box className="modal-buttons">
                <Button id="dismiss-modal" className="modal-cancel" onClick={toggleModal} disableRipple>
                    Cancel
                </Button>
                <Button id="confirm-modal" className="modal-confirm" onClick={action} disableRipple>
                    Confirm
                </Button>
            </Box>
          </>
        )}
        {(type === constants.expire && 
          <Box className="modal-buttons">
            <Button id="confirm-modal" className="modal-confirm" onClick={action} disableRipple>
              Continue session
            </Button>        
          </Box>
        )}
        {((type === constants.changeLoginId || type === constants.reports) &&
          <Box className="modal-buttons">
            <Button id="dismiss-modal" className="modal-cancel" onClick={toggleModal} disableRipple>
              Cancel
            </Button>
            <Button id="confirm-modal" className="modal-confirm" onClick={action} disableRipple>
              Continue
            </Button>
          </Box>
        )}
      </Box>
    </Box>

  )
}

